import { useQuery } from '@tanstack/react-query';

import { getUrlToBackendApi, request } from '@shared/services/api';

import { PaginationType, PromotionDetailedType } from '@types';

const ALL_PROMOTIONS_REQUEST_URL = '/lotteries';

export const GET_ALL_PROMOTIONS_QUERY_KEY = ['promotions', 'list'];

type PROMOTION_REQUEST_TYPE = {
	status: string;
	data: PromotionDetailedType[];
	pagination: PaginationType;
};

export enum PROMOTION_REQUEST_STATUS {
	CURRENT = 'current',
	COMPLETED = 'completed'
}

const CACHE_TIME = 60000 * 5;

export const useQueryPromotions = (status: PROMOTION_REQUEST_STATUS) => {
	return useQuery<unknown, unknown, PROMOTION_REQUEST_TYPE>({
		queryKey: [GET_ALL_PROMOTIONS_QUERY_KEY, status],
		queryFn: () => {
			return request<PROMOTION_REQUEST_TYPE>({
				method: 'get',
				url: getUrlToBackendApi(ALL_PROMOTIONS_REQUEST_URL + '?status=' + status).href
			});
		},
		retry: false,
		staleTime: CACHE_TIME
	});
};
